"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

require("../style/index.css");

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var Grid =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Grid, _Component);

  function Grid() {
    (0, _classCallCheck2["default"])(this, Grid);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).apply(this, arguments));
  }

  (0, _createClass2["default"])(Grid, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          variant = _this$props.variant,
          className = _this$props.className,
          children = _this$props.children,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["variant", "className", "children"]);
      var classes = (0, _classnames["default"])({
        'spectrum-grid--fixed': variant === 'fixed',
        'spectrum-grid--fluid': variant === 'fluid'
      }, className);
      return _react["default"].createElement("div", (0, _extends2["default"])({
        className: classes
      }, (0, _filterDOMProps["default"])(otherProps)), children);
    }
  }]);
  return Grid;
}(_react.Component);

exports["default"] = Grid;
(0, _defineProperty2["default"])(Grid, "propTypes", {
  /**
   * Based on http://flexboxgrid.com/
   * Fluid is percentage based
   * Fixed is values for each incrementally sized viewport (xs, sm, md, lg, etc.)
   */
  variant: _propTypes["default"].oneOf(['fixed', 'fluid'])
});
(0, _defineProperty2["default"])(Grid, "defaultProps", {
  variant: 'fluid'
});